import { FaLaptopCode, FaShieldAlt, FaBolt, FaMobileAlt } from "react-icons/fa";
import wordpressQualitiesJson from "../../data/wordpressQualities3.json";

export default function Section8() {
  const wordpressQualitiesData = wordpressQualitiesJson;

  // Cycle through icons for each quality
  const icons = [FaLaptopCode, FaShieldAlt, FaBolt, FaMobileAlt];

  return (
    <div className="Section8 py-[0px] md:py-[100px] bg-[#f9f9f9]">
      {/* Heading */}
      <div className="text-center mb-16 max-w-4xl mx-auto">
        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          Why Having a <span className="text-[#DA2128]">WordPress Website</span> Is Essential for UAE Businesses
        </h2>
        <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[600px] mx-auto">
          In the UAE’s competitive market, your website is more than just an online presence, it’s your digital storefront that operates 24/7. A professionally built WordPress website helps you:
        </p>
      </div>

      {/* Grid with Icons */}
      <div className="flex flex-wrap justify-center gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
        {wordpressQualitiesData.map((item, index) => {
          const IconComponent = icons[index % icons.length];
          return (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 rounded-2xl bg-white shadow-md w-[260px]"
            >
              <div className="mb-4">
                <IconComponent className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
              </div>
              <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515] mb-2">
                {item.title}
              </h3>
              <p className="text-[14px] md:text-[15px] leading-[22px] text-[#555]">
                {item.text}
              </p>
            </div>
          );
        })}
      </div>



      {/* Bottom Text */}
      <div className="text-center mt-12 w-[90%] md:w-[61%] mx-auto">
        <p className="text-[#555] text-[16px] md:text-[18px] leading-[22px]">
          Whether you’re a startup in Dubai or an established brand expanding in Abu Dhabi, a well-optimized WordPress website is your foundation for online growth.
        </p>
      </div>
    </div>
  );
}
